import React from "react";
import "../css/spinner.css";

const Spinner = () => {
  return (
    <div>
      <div className="content">
        <div className="ball-beat">
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
};
export default Spinner;
